<template lang="pug">
div.row
    div.col-xs-12.variants(
        v-for="(ingredient, index) in variant.ingredients"
        :key="index"
    )
        div(:class="{ 'col-xs-6': hasMultipleIngredient, 'col-xs-7': !hasMultipleIngredient }")
            div.md-form-group.p-t-0
                label.typo__label.multiselect-label.font-sm Ingredient
                multiselect(
                    track-by="id"
                    label="name"
                    :options="ingredientList"
                    :loading="onLoading('fetch-ingredients')"
                    v-model="ingredient.ingredient"
                    :allow-empty="false"
                    v-validate="'required'"
                    :data-vv-scope="`variant_${variant.sequence}_ingredient_${index}`"
                    @search-change="loadIngredients"
                    @open="open()"
                    @close="close()"
                )
                span.small.text-danger(v-if="errors.has(`variant_${variant.sequence}_ingredient_${index}`)")
                    | {{ errors.first(`variant_${variant.sequence}_ingredient_${index}`) }}

        div.col-xs-3
            div.md-form-group
                input.md-input.m-t-1.small(
                    v-model="ingredient.ingredient.uom"
                    disabled
                )
                label Measurement

        div.col-xs-2
            div.md-form-group
                input.md-input.m-t-1(
                    type="number"
                    v-model="ingredient.portion"
                    min="0"
                    step="any"
                    required
                )
                label Portion (#)

        div.col-xs-1(v-if="hasMultipleIngredient")
            i.text-muted.material-icons.md-18.btn-del-list.pointer.m-t-md(
                @click="removeIngredient(index)"
            ) &#xe14c;

    div.col-xs-12.text-right.m-t-sm.p-b-3
        button.btn.btn-outline.btn-sm.rounded.b-success.text-success(
            type="button"
            @click="addIngredient()"
        )
            i.material-icons.md-18 &#xe145;
            | Add Recipes
</template>

<script>
import ingredientStoreMixin from '../../inventory-fnb/ingredient/store-mixin';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import handleValidatorUI from '@js/mixins/handle-validator-ui';

export default {
    mixins: [ingredientStoreMixin, handleValidatorUI],

    props: {
        product: {
            type: Object,
            required: true,
        },

        variant: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            hasValidationError: false,
        };
    },

    computed: {
        ...mapGetters('ingredient', [
            'ingredientList',
            'originalIngredientList',
        ]),

        hasMultipleIngredient() {
            return this.variant.ingredients.length > 1;
        },
    },

    methods: {
        ...mapActions('ingredient', ['getIngredientList']),

        ...mapMutations('ingredient', ['setIngredientList']),

        addIngredient() {
            let ingredient = {
                id: null,
                portion: null,
                ingredient: {
                    id: null,
                    uom: null,
                },
            };

            this.variant.ingredients.push(ingredient);
        },

        removeIngredient(index) {
            this.variant.ingredients.splice(index, 1);
        },

        validate() {
            this.hasValidationError = false;

            this.variant.ingredients.map((ingredient, index) => {
                this.validateField(
                    ingredient.ingredient.id,
                    `variant_${this.variant.sequence}_ingredient_${index}`,
                    'ingredient',
                );
            });
        },

        loadIngredients: _.debounce(function(query = '') {
            const params = {
                query,
                outlet_id: this.product.outlet_id,
                mergeIds: this.getExistingIngredientIds(),
            };

            this.getIngredientList(params);
        }, 500),

        open() {
            const mergeIds = this.getExistingIngredientIds();

            const data = this.ingredientList.filter(
                i => !mergeIds.includes(i.id),
            );

            this.setIngredientList(data);
        },

        close() {
            this.setIngredientList(this.originalIngredientList);
        },

        getExistingIngredientIds() {
            let variantIngredients = _.map(
                this.variant.ingredients,
                'ingredient',
            );

            let productIngredients = _.map(
                this.product.ingredients,
                'ingredient',
            );

            let vIds = _.map(variantIngredients, 'id');
            let pIds = _.map(productIngredients, 'id');

            return [...vIds, ...pIds];
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/variant-ingredient.vue